import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box
} from "@mui/material";

interface GlobalModalProps {
  open: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  icon?: React.ReactNode; // optional icon
  children?: React.ReactNode;
}

const GlobalModal: React.FC<GlobalModalProps> = ({
  open,
  title,
  description,
  confirmText = "Submit",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  icon, // if undefined, won’t show
  children,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          {icon && <span>{icon}</span>}
          <Typography variant="h6">{title}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{description}</Typography>
        {children}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "end", pb: 2 }}>
        <Button variant="text" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button
          variant="secondary"
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalModal;
